import { render, staticRenderFns } from "./SubCompany.vue?vue&type=template&id=7e64199a&scoped=true"
import script from "./SubCompany.vue?vue&type=script&lang=js"
export * from "./SubCompany.vue?vue&type=script&lang=js"
import style0 from "./SubCompany.vue?vue&type=style&index=0&id=7e64199a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64199a",
  null
  
)

export default component.exports